/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PauseTaskCommand } from '../../models/pause-task-command';
import { PauseTaskCommandResult } from '../../models/pause-task-command-result';

export interface ApiTaskPauseTaskPut$Plain$Params {
      body?: PauseTaskCommand
}

export function apiTaskPauseTaskPut$Plain(http: HttpClient, rootUrl: string, params?: ApiTaskPauseTaskPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<PauseTaskCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiTaskPauseTaskPut$Plain.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PauseTaskCommandResult>;
    })
  );
}

apiTaskPauseTaskPut$Plain.PATH = '/api/Task/PauseTask';
